/**
*	@constructor Script used for an html5 charts page
*/
var Html5Charts = function () {

};

(function ($) {

	/**
	*	@description Method used to initialize Html5Charts
	*/
	Html5Charts.prototype.init = function () {

		// Initialize chart
		var chart = this.initChart(), self = this;

		// Initialize clipboards
		new ChartworksClipboard('#code-sample-copy-btn').init();
		new ChartworksClipboard("#share-chart-copy-btn").init();
		
		// data table button (JPHK-206, CW-1337)
		$(".chartworks-datatable-btn").on("click", function(e){
			var html = self.getDataTableHTML(chart.getExportData());
			$("#chart-datatable").html(html);
		})
	};

	/**
	*	@description Method used to generate an HTML table from Chartworks export data
	*/
	Html5Charts.prototype.getDataTableHTML = function (data) {
		var html = [];
		html.push('<h2 class="h2">Data Table</h2>');
		html.push('<table>');
		html.push('<caption>OHLC data from example demo chart</caption>');
		html.push('<thead><tr>');
		data.columns.forEach(function(col){
			html.push('<th scope="col">' + col + '</th>');
		});
		html.push('</tr></thead>');
		html.push('<tbody>');
		data.series.forEach(function(row){
			html.push('<tr>');
			data.columns.forEach(function(col, idx){
				if (idx === 0){
					html.push('<th scope="row">' + row[col] + '</th>');
				} else {
					html.push('<td>' + row[col] + '</td>');
				}
			});
			html.push('</tr>');
		});
		html.push('</tbody></table>');
		return html.join('');
	};

	/**
	*	@description Method used to initialize a MOD chart for an html5 charts page
	*/
	Html5Charts.prototype.initChart = function () {

		var isSaved = typeof window.chartID !== "undefined", self = this, cultureCode = this.getCultureCode(), vimeoId = this.getVimeoId();

		window.chart = new ChartworksBuilder({
			"token": "demo-token",
			"chartID": isSaved ? window.chartID : null,
			"target": "#chart-target",
			"symbol": "AAPL",
			"exchange": "NSQ",
			"timeframe": "1y",
			"realTime": false,
			"typeAheadAPI": "https://api.markitondemand.com/apiman-gateway/MOD/chartworks-xref/1.0/xref/predictive?search=%s",
			"compareMenuOptions": [{
				"symbol": "MSFT",
				"exchange": "NSQ",
				"displayName": "Microsoft Corp"
			}],
			"cultureCode": cultureCode,
			"style.indicator.price.lineColor": "orange",
			"style.indicator.price.lineWidth": "3",
			"panel.lower.indicator": "Volume",
			"feature.symbolSearch": true,
			"feature.comparison": true,
			"feature.timeframe": true,
			"feature.indicators": true,
			"feature.intraday": true,
			"feature.events": true,
			"feature.markerType": true,
			"feature.saveLoad": false,
			"feature.share": true,
			"feature.tools": true,
			"theme": "dark",
			"onChartLoad": isSaved ? null : function () {
				// get the date 30 days ago
				var d30 = new Date();
				d30.setDate(d30.getDate() - 30);

				// get the date 150 days ago
				var d150 = new Date();
				d150.setDate(d150.getDate() - 150);

				// add custom events
				this.loadCustomEvents(
					[{
						label: "Custom events",
						display: true,
						dataset: [{
							"date": d30.toISOString(),
							"iconCharacter": "P",
							"iconCharacterColor": "black",
							"iconBackgroundColor": "white",
							"rolloverTitle": "Prediction",
							"rolloverBodyHTML": "30 days from now you'll view this <a href=\"https://chartworks.io/Documentation/html5#html5-methods-loadCustomEvents\" target=\"_blank\" style=\"color:#2BA92B!important\">custom event</a>!"
						}, {
							"date": d150.toISOString(),
							"iconCharacter": "V",
							"iconCharacterColor": "white",
							"iconBackgroundColor": "#2BA92B",
							"rolloverTitle": "Chartworks Video",
							"rolloverBodyHTML": "<a href=\"https://vimeo.com/" + vimeoId + "\" target=\"_blank\" style=\"color:#2BA92B!important\">Watch the full version</a><br><br><iframe src=\"https://player.vimeo.com/video/" + vimeoId + "\" width=\"150\" height=\"84\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
						}]
					}]
				);
			},
			"onPrimarySymbolChange": function (args) {

				// Display a nice message when trying to get unentitled data
				if (args.symbol != "AAPL" && args.symbol != "MSFT") {
					this.showDialog(self.translate("Alert"), self.translate("ThisDemoIsOnlyEntitled"));
				}
			},
			"onAPIError": function (apiError) {

				// handle 401 (unauthorized)
				if (apiError.status === 401) {

					// use getInvalidTokenCount to ensure we don't get stuck in an
					// endless loop if we keep creating bad tokens
					if (this.getInvalidTokenCount() < 5) {
						// set token
						this.setConfigParam("token", "demo-token");

						// load data
						this.loadData();

					} else { // fail after 5 unsuccessful tries
						this.showDialog("Alert", "Looks like we are having some issues at the moment. We'll be back up soon!");
					}
				} else { // print other errors in the console
					console.log(apiError.status, apiError.statusMsg);
				}
			},
			"onShare": function (args) {
				
				var shareTwitterURL = this.getEnvironment() === "P" ? "https://www.chartworks.io/charts/loadchart/" + args.chartID : "https://chartworks.markitqa.com/public/charts/loadchart/" + args.chartID,
					shareURL = "../charts/loadchart/" + args.chartID;
    
				this.showDialog("<h6>Share Chart URL</h6><input id=\"share-chart-url\" type=\"text\" value=\"" + shareTwitterURL + "\"/><button id=\"share-chart-copy-btn\" class=\"btn btn-default control chartworks-share-url-btn\" data-clipboard-target=\"#share-chart-url\"><span class=\"btn-text\" style=\"opacity: 1;\">Copy</span></button><p><iframe id=\"twitter-widget-0\" scrolling=\"no\" frameborder=\"0\" allowtransparency=\"true\" class=\"twitter-share-button twitter-share-button-rendered twitter-tweet-button\" title=\"Twitter Tweet Button\" src=\"https://platform.twitter.com/widgets/tweet_button.d73d0c4cb6af3df0ea22b7c11dbc87d2.en.html#dnt=false&amp;id=twitter-widget-0&amp;lang=en&amp;size=m&amp;text=Check%20out%20my%20%24" + this.getCurrentSymbol() + "%20chart%3A%20&amp;type=share&amp;url=" + shareTwitterURL + "\" style=\"position: static; visibility: visible; width: 60px; height: 20px;\"></iframe></p>");
			},
			"environment": ChartworksBuilder.prototype.getEnvironment()
		});
		
		return window.chart;
	};

	Html5Charts.prototype.translate = function (id) {

		var map = {
			"Alert": {
				"en": "Alert",
				"ja": "アラート"
			},
			"ThisDemoIsOnlyEntitled": {
				"en": "This demo is only entitled to symbols AAPL and MSFT on the NASDAQ. All other symbols will fail.",
				"ja": "本デモはサンプルとしてNASDAQ上の「AAPL」及び「MSFT」のみのデータのために作成しています。他シンボールの検索はエラーになります。"
			}
		},
		languageId = this.getCultureCode().substring(0, 2);

		return map[id][languageId];
	}

	Html5Charts.prototype.getCultureCode = function () {

		var culture = window.cultureID || "en-US";

		if (culture == "ja") {
			return "ja-JP";
		} else {
			return "en-US";
		}
	}

	Html5Charts.prototype.getVimeoId = function () {

		var culture = window.cultureID || "en-US";

		if (culture == "ja") {
			return "209254386";
		} else {
			return "165624026";
		}
	}

})(jQuery);
